import defo from '@icelab/defo';
import { viewObservers } from './viewsObservers';

/**
 * This module is useful for defining generic behaviour that is connected to the
 * DOM. It uses https://www.npmjs.com/package/@icelab/defo as the library to
 * connect individual DOM elements to their matching view functions, which are
 * defined in ./views
 */

/**
 * Set defo prefix to `ca`. This means we call it in the DOM with the convention:
 *
 *    data-ca-#{view-observer-name}={...}
 */
const prefix = 'ca';

/**
 * Initialize defo
 *
 * Defo can/should be initialized without waiting for DOMContentLoaded as it
 * binds separately from the DOM and then watches for changes
 */
defo({ prefix, views: viewObservers });
